const style = {
  width: '100%',
  display: 'grid',
  gridRowGap: '20px',
}

const PropertyList = ({ children }) => <div style={style}>{children}</div>

export default PropertyList
